// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/UploadPhoto/UploadPhoto.scss
// module id = 716
// module chunks = 0